import AccordionSection from 'components/contentBlocks/AccordionSection';
import React from 'react';
import { cmsTextContentProp } from 'utils/proptypes/modules/textProps';
import transformTextSection from 'libs/wordpress/utils/transfromTextSection';

const AccordionBlock = ({ content = {} }) => {
    const { items } = content;

    const transformedItems = items?.map(item => ({
        anchorTag: item.anchor_tag,
        label: item.label,
        data: transformTextSection(item.data),
    }));

    return <AccordionSection items={transformedItems} />;
};

AccordionBlock.propTypes = {
    content: cmsTextContentProp,
};

export default AccordionBlock;
